<div class="maps-container">
	<div #gmap class="google-maps"></div>
	<div class="lock-button" (click)="toggleLock()">
		<i [ngClass]="lockClasses"></i>
	</div>
</div>
